import React from 'react';
import { Box, Typography } from '@mui/material';

const T = {
  primary: '#526075', primaryContainer: '#d5e3fd',
  surfaceLow: '#f1f4f5',
  text: '#2d3335', secondary: '#556071',
  font: '"Manrope", system-ui, sans-serif',
  fontBody: '"Inter", system-ui, sans-serif',
};

const Icon = ({ name, size = 26, sx = {} }) => (
  <span
    className="material-symbols-outlined"
    style={{ fontSize: size, fontVariationSettings: "'FILL' 0, 'wght' 400", ...sx }}
  >
    {name}
  </span>
);

/**
 * @param dense  Compacte variant: kleiner icoon, kleinere titel, minder marge eronder.
 *               Bedoeld voor schermen waar de inhoud zelf het werk is en de header
 *               alleen nog moet zeggen wáár je bent (Dagstart, gedeeld op een beamer).
 *               Overal anders blijft de ruime versie staan; dit is opt-in.
 */
export default function PageHeader({ icon = 'dashboard', title, subtitle, accent, rightActions, logoUrl, fallbackText, dense = false }) {
  const bg = accent?.bg || T.primaryContainer;
  const color = accent?.color || T.primary;
  const vak = dense ? 36 : 48;

  const renderVisual = () => {
    if (logoUrl) {
      return (
        <Box sx={{ width: vak, height: vak, borderRadius: '0.75rem', bgcolor: T.surfaceLow, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, p: 0.5 }}>
          <Box component="img" src={logoUrl} alt="" sx={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '0.5rem' }} />
        </Box>
      );
    }
    if (fallbackText) {
      return (
        <Box sx={{ width: vak, height: vak, borderRadius: '0.75rem', bgcolor: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Typography sx={{ fontFamily: T.font, fontSize: dense ? '0.85rem' : '1rem', fontWeight: 800, color }}>{fallbackText}</Typography>
        </Box>
      );
    }
    return (
      <Box sx={{ width: vak, height: vak, borderRadius: '0.75rem', bgcolor: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon name={icon} size={dense ? 20 : 26} sx={{ color }} />
      </Box>
    );
  };

  return (
    // flexWrap: op smalle schermen zakken de rightActions naar een eigen regel —
    // anders wordt de titel/subtitle tot een woord-per-regel kolom geplet.
    <Box sx={{ display: 'flex', alignItems: 'center', gap: dense ? 1.5 : 2, mb: dense ? 1.5 : { xs: 3, sm: 5 }, flexWrap: 'wrap' }}>
      {renderVisual()}
      <Box sx={{ flex: 1, minWidth: 220 }}>
        <Typography sx={{ fontFamily: T.font, fontSize: dense ? '1.25rem' : { xs: '1.5rem', sm: '1.8rem' }, fontWeight: 800, color: T.text, letterSpacing: '-0.03em' }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ fontFamily: T.fontBody, fontSize: '0.82rem', color: T.secondary }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {rightActions && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
          {rightActions}
        </Box>
      )}
    </Box>
  );
}
